// extracted by mini-css-extract-plugin
export var introContainer = "Team-module--introContainer--zvUO9";
export var introContent = "Team-module--introContent--2jP82";
export var spacing = "Team-module--spacing--azfdw";
export var heading = "Team-module--heading--sRbDm";
export var title = "Team-module--title--1L6fY";
export var text = "Team-module--text--OW6iG";
export var member = "Team-module--member--Z6190";